module.exports = __webpack_public_path__ + "img/20220518144740594gee.60eb8fcd.jpg";